import { render, staticRenderFns } from "./StyledInput.vue?vue&type=template&id=630d61a8&scoped=true"
import script from "./StyledInput.vue?vue&type=script&lang=js"
export * from "./StyledInput.vue?vue&type=script&lang=js"
import style0 from "./StyledInput.vue?vue&type=style&index=0&id=630d61a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630d61a8",
  null
  
)

export default component.exports